const DEV_DEPLOY_TIERS = new Set(["dev", "dev2", "development"]);

/** Explicit deployment tiers take precedence over the local development server. */
export function areAdvancedEditorFeaturesEnabled(
  deployTier = process.env.REACT_APP_DEPLOY_TIER ?? "",
  nodeEnv = process.env.NODE_ENV ?? "",
): boolean {
  const tier = deployTier.trim().toLowerCase();
  return DEV_DEPLOY_TIERS.has(tier) || (tier === "" && nodeEnv === "development");
}
